import React, { useState } from 'react';
import { FlagIcon, PencilLineIcon } from 'lucide-react';
import { ledgerRows } from '../../data/ledger';
import { useAssessment } from '../../contexts/AssessmentContext';
import { formatEur } from '../../utils/scoring';
import { FlagDrawer } from './FlagDrawer';
export function LedgerTable() {
  const {
    flags,
    saveFlag,
    removeFlag,
    locked,
    timeUp
  } = useAssessment();
  const [drawer, setDrawer] = useState<{
    rowId: string;
    label: string;
    kind: 'flag' | 'correction';
  } | null>(null);
  const readOnly = locked || timeUp;
  return <div className="flex h-full flex-col" data-id="element-341" data-mp="2hvf9o3wi8wsw">
      <div className="border-b border-slate-200 bg-white px-5 py-3" data-id="element-342" data-mp="2luen6cway1vy">
        <h2 className="text-sm font-semibold text-slate-900" data-id="element-343" data-mp="2lx9783belkou">
          General ledger and bank statement — Meridian SAS, Q2 2026, EUR
        </h2>
        <p className="mt-0.5 text-xs text-slate-500" data-id="element-344" data-mp="13nob5wluj9e">
          Bank descriptors are reproduced as received from the clearing system.
        </p>
      </div>

      <div className="flex-1 overflow-auto" data-id="element-345" data-mp="3v3o0feo3ji52">
        <table className="w-full border-collapse text-sm" data-id="element-346" data-mp="3v2czrnpy6qi6">
          <thead className="sticky top-0 z-10 bg-slate-100 text-left" data-id="element-347" data-mp="3q4unpogmvv5y">
            <tr className="text-[11px] uppercase tracking-wider text-slate-600" data-id="element-348" data-mp="3q2i5rbavlksw">
              <th className="border-b border-slate-200 px-4 py-2.5 font-semibold" data-id="element-349" data-mp="3l3x9fmyqvl9q">Ref</th>
              <th className="border-b border-slate-200 px-4 py-2.5 font-semibold" data-id="element-350" data-mp="3g5voewhrdbvm">Date</th>
              <th className="border-b border-slate-200 px-4 py-2.5 font-semibold" data-id="element-351" data-mp="3c5lkdpdj0vje">Account</th>
              <th className="border-b border-slate-200 px-4 py-2.5 font-semibold" data-id="element-352" data-mp="37d24glrd9obf">GL counterparty</th>
              <th className="border-b border-slate-200 px-4 py-2.5 text-right font-semibold" data-id="element-353" data-mp="32fs8en9h2eem">GL amount</th>
              <th className="border-b border-slate-200 px-4 py-2.5 font-semibold" data-id="element-354" data-mp="2xh8o0raj1aod">Bank ref</th>
              <th className="border-b border-slate-200 px-4 py-2.5 font-semibold" data-id="element-355" data-mp="2sfj930k6ocv0">Bank descriptor</th>
              <th className="border-b border-slate-200 px-4 py-2.5 text-right font-semibold" data-id="element-356" data-mp="2ogir1k9j5e92">Bank amount</th>
              <th className="border-b border-slate-200 px-4 py-2.5 font-semibold" data-id="element-357" data-mp="2dskl5fkjc0l1">Actions</th>
            </tr>
          </thead>
          <tbody data-id="element-358" data-mp="2iqugbq69f16n">
            {ledgerRows.map(row => {
            const entry = flags[row.id];
            return <React.Fragment key={row.id} data-id="element-359" data-mp="29s0kw34o0guo">
                  <tr className="border-b border-slate-100 bg-white transition-colors hover:bg-slate-50" data-id="element-360" data-mp="29ssj7lpncson">
                    <td className="whitespace-nowrap px-4 py-2.5 font-mono-num text-xs text-slate-500" data-id="element-361" data-mp="2xiwijgvsy69u">
                      {row.id}
                    </td>
                    <td className="whitespace-nowrap px-4 py-2.5 text-xs text-slate-600" data-id="element-362" data-mp="2nr8od87v2b4o">{row.date}</td>
                    <td className="px-4 py-2.5" data-id="element-363" data-mp="2sqcxjyusc8v0">
                      <p className="text-slate-900" data-id="element-364" data-mp="2sp1trz1cb13w">{row.account}</p>
                      <p className="text-xs text-slate-500" data-id="element-365" data-mp="3gfec83u7og8q">{row.description}</p>
                    </td>
                    <td className="px-4 py-2.5 text-slate-800" data-id="element-366" data-mp="3l90c0vfa0pn4">{row.counterparty}</td>
                    <td className="whitespace-nowrap px-4 py-2.5 text-right font-mono-num text-slate-900" data-id="element-367" data-mp="3ul6eyuz6k4h1">
                      {formatEur(row.glAmount)}
                    </td>
                    <td className="whitespace-nowrap px-4 py-2.5 font-mono-num text-xs text-slate-500" data-id="element-368" data-mp="85v6xt0651mx">
                      {row.bankRef}
                    </td>
                    <td className="px-4 py-2.5 font-mono-num text-[12.5px] text-slate-800" data-id="element-369" data-mp="3bnn7vwwa8vx9">
                      {row.bankDescriptor}
                    </td>
                    <td className="whitespace-nowrap px-4 py-2.5 text-right font-mono-num text-slate-900" data-id="element-370" data-mp="37nmgzcrzys9b">
                      {formatEur(row.bankAmount)}
                    </td>
                    <td className="whitespace-nowrap px-4 py-2.5" data-id="element-371" data-mp="3glyfe0z3uucb">
                      <div className="flex items-center gap-1.5" data-id="element-372" data-mp="10vbzcqnsgij5">
                        <button type="button" disabled={readOnly} onClick={() => setDrawer({
                      rowId: row.id,
                      label: `${row.account} — ${row.description}`,
                      kind: 'flag'
                    })} className="inline-flex items-center gap-1 rounded-md border border-slate-200 bg-white px-2 py-1 text-xs font-medium text-slate-600 transition-colors hover:border-slate-300 hover:text-slate-900 disabled:opacity-40" data-id="element-373" data-mp="10xomdi8elj32">
                          <FlagIcon className="h-3 w-3" data-id="element-374" data-mp="3kiuaqdmk26ue" />
                          Flag
                        </button>
                        <button type="button" disabled={readOnly} onClick={() => setDrawer({
                      rowId: row.id,
                      label: `${row.account} — ${row.description}`,
                      kind: 'correction'
                    })} className="inline-flex items-center gap-1 rounded-md border border-slate-200 bg-white px-2 py-1 text-xs font-medium text-slate-600 transition-colors hover:border-slate-300 hover:text-slate-900 disabled:opacity-40" data-id="element-375" data-mp="3pgnihb3ib8ws">
                          <PencilLineIcon className="h-3 w-3" data-id="element-376" data-mp="1nlg8g4arbmng" />
                          Correct
                        </button>
                        {entry && <span className="rounded-full border border-teal-200 bg-teal-50 px-2 py-0.5 text-[11px] font-medium text-teal-800" data-id="element-377" data-mp="2fbb0w9twvsgc">
                            {entry.kind === 'correction' ? 'corrected' : 'flagged'}
                          </span>}
                      </div>
                    </td>
                  </tr>
                  {entry && <tr className="bg-teal-50/40" data-id="element-378" data-mp="2z0ldvg29vzar">
                      <td colSpan={9} className="border-b border-slate-100 px-4 py-2 text-xs text-teal-900" data-id="element-379" data-mp="2z26arcc27ubs">
                        <span className="font-semibold" data-id="element-380" data-mp="3d5vit64xl191">Your entry: </span>
                        {entry.what}
                        <span className="ml-2 text-teal-700/70" data-id="element-381" data-mp="3i4ovwxgb2q8o">
                          · {entry.actionType} · sources {entry.sources.join(', ') || 'none cited'}
                        </span>
                      </td>
                    </tr>}
                </React.Fragment>;
          })}
          </tbody>
        </table>
      </div>

      {drawer && <FlagDrawer rowId={drawer.rowId} rowLabel={drawer.label} kind={drawer.kind} existing={flags[drawer.rowId]} onSave={saveFlag} onDelete={() => removeFlag(drawer.rowId)} onClose={() => setDrawer(null)} data-id="element-382" data-mp="2zeh070exr22i" />}
    </div>;
}